/* eslint-disable react/prop-types */
import React, { Component } from "react";
import { connect } from "react-redux";
import {
  Table, Form, Grid, Segment, Accordion,
  Divider, Statistic, Icon, Popup, Modal, Header, Button, Image
} from "semantic-ui-react";
import { withRouter } from "react-router-dom";
import Constants from "./utilities/Constants";
import Strings from "./utilities/Strings";
import Utils from "./utilities/Utils";

const UtilsInstance = new Utils();

const statusKeyArray = [Strings.GOOD_STRING, Strings.BAD_STRING, Strings.ATTENTION_STRING, Strings.FAULT_STRING];
const statusValueArray = [Constants.GOOD, Constants.BAD, Constants.ATTENTION, Constants.FAULT];

class LiveList extends Component {
  // Intialize this component state
  constructor(props) {
    super(props);
    this.state = {
      formInput: "",
      column: null,
      sortDirection: "ascending",
      originalDevices: [],
      devices: [],
      isColumnClicked: false,
      baudrate: 0,
      nMasters: 0,
      nSlaves: 0,
      errorMessages: [],
      firstScanFail: false,
      uptime: "",
      channelTag: "",
      clickedDevice: "",
      showModal: false,
      showZeroIpModal: false,
    };
  }

  getUnbalanceImage = () => (<Image src={`${process.env.PUBLIC_URL}/images/unbalance.png`} />);

  getDaysInMonth = (month, year) => {
    if (typeof year == "undefined") year = 1999; // any non-leap-year works as default     
    let currmon = new Date(year, month),
      nextmon = new Date(year, month + 1);
    return Math.floor((nextmon.getTime() - currmon.getTime()) / (24 * 3600 * 1000));
  }

  getDateTimeSince = (target) => { // target should be a Date object
    let now = new Date(), yd, md, dd, hd, nd, sd, out = [];

    yd = now.getFullYear() - target.getFullYear();
    md = now.getMonth() - target.getMonth();
    dd = now.getDate() - target.getDate();
    hd = now.getHours() - target.getHours();
    nd = now.getMinutes() - target.getMinutes();
    sd = now.getSeconds() - target.getSeconds();

    if (md < 0) { yd--; md += 12; }
    if (dd < 0) {
      md--;
      dd += this.getDaysInMonth(now.getMonth() - 1, now.getFullYear());
    }
    if (hd < 0) { dd--; hd += 24; }
    if (nd < 0) { hd--; nd += 60; }
    if (sd < 0) { nd--; sd += 60; }

    if (yd > 0) out.push(yd + Strings.YEAR + (yd === 1 ? "" : "s"));
    if (md > 0) {
      if (md === 1) {
        out.push(md + Strings.MONTH);
      }
      else {
        out.push(md + Strings.MONTHS);
      }
    }
    if (dd > 0) out.push(dd + Strings.DAY + (dd === 1 ? "" : "s"));
    if (hd > 0) out.push(hd + Strings.HOUR + (hd === 1 ? "" : "s"));
    if (nd > 0) out.push(nd + Strings.MINUTE + (nd === 1 ? "" : "s"));
    //if (sd > 0) out.push(sd + " segundo" + (sd === 1 ? "" : "s"));
    return out.join(" ");
  }

  formatToRelativeTime = (uptimeInSeconds) => {
    if (uptimeInSeconds !== undefined) {
      const uptimeInMillis = uptimeInSeconds * 1000;
      const timeNow = new Date().getTime();
      const whenWasTurnedOn = timeNow - uptimeInMillis;
      const dateWhenWasTurnedOn = new Date(whenWasTurnedOn);
      return this.getDateTimeSince(new Date(dateWhenWasTurnedOn));
    }
  }

  closeModal = () => this.setState({ showModal: false })

  handleModalDeleteClick = () => {
    this.setState({
      showModal: false,
    });
    this.removeFaultDevice(this.state.clickedDevice);
  }

  removeFaultDevice = (deviceAddress) => {
    let data = JSON.stringify({
      address: deviceAddress
    });

    fetch(Constants.REQUEST_IP_ADDRESS + "remove_POST/" + parseInt(localStorage.getItem(Constants.ACTIVE_CHANNEL)), {
      method: "POST",
      headers: {
        "Content-Type": "application/json;charset=UTF-8"
      },
      body: data
    })
      .then(UtilsInstance.checkStatus)
      .then(() => {
        alert(Strings.REMOVE_DEVICE_SUCCESS);
      })
      .catch((error) => {
        alert(Strings.REMOVE_DEVICE_FAILURE + "\n" + Strings.REASON_H1 + error);
      });
  }

  // Since the devices in H1 protocol are not numbered with simple integers
  // We need to convert, 1A and 1B for exemple, into sortable integers
  // Every device that has A in its address has its number as the sortable integer
  // Every device that has B in its addres, has its number + 32 as the sortable integer
  // Every device that has master in its name has its number be 0
  addOrderAndSeverityToDevices = (devices) => {

    for (let i = 0; i < devices.length; i++) {
      if (devices[i].status === Constants.FAULT) {
        devices[i].severity = 5;
      } else if (devices[i].status === Constants.BAD) {
        devices[i].severity = 4;
      } else if (devices[i].status === Constants.ATTENTION) {
        devices[i].severity = 3;
      } else if (devices[i].status === Constants.GOOD) {
        devices[i].severity = 2;
      } else {
        devices[i].severity = 1;
      }
      // Adding order value
      let deviceName = devices[i].address;

      devices[i].order = parseInt(deviceName);
    }
    devices.sort(UtilsInstance.sortBy("order", false, parseInt));
  }

  // Sorts the table when the user clicks on one of the columns
  handleSort = clickedColumn => () => {

    this.setState({ isColumnClicked: true });

    // The user wants to order the live list by address ascending
    if (clickedColumn === "address" && this.state.sortDirection === "ascending") {
      this.setState({
        column: clickedColumn,
        devices: this.state.devices.sort(
          UtilsInstance.sortBy(
            "address",
            false,
            parseInt)),
        sortDirection: "descending",
      });
    }
    // The user wants to order the live list by address descending
    else if (clickedColumn === "address" && this.state.sortDirection === "descending") {
      this.setState({
        column: clickedColumn,
        devices: this.state.devices.sort(
          UtilsInstance.sortBy(
            "address",
            true,
            parseInt)),
        sortDirection: "ascending",
      });
    }
    // The user wants to order the live list by tag ascending
    else if (clickedColumn === "tag" && this.state.sortDirection === "ascending") {
      this.setState({
        column: clickedColumn,
        devices: this.state.devices.sort(
          UtilsInstance.sortBy(
            "tag",
            false,
            function (a) { return UtilsInstance.treatUppercase(a); })),
        sortDirection: "descending",
      });
    }
    // The user wants to order the live list by tag descending
    else if (clickedColumn === "tag" && this.state.sortDirection === "descending") {
      this.setState({
        column: clickedColumn,
        devices: this.state.devices.sort(
          UtilsInstance.sortBy(
            "tag",
            true,
            function (a) { return UtilsInstance.treatUppercase(a); })),
        sortDirection: "ascending",
      });
    }
    // The user wants to order the live list by amplitude ascending
    else if (clickedColumn === "amplitude" && this.state.sortDirection === "ascending") {
      this.setState({
        column: clickedColumn,
        devices: this.state.devices.sort(
          UtilsInstance.sortBy(
            "amplitude",
            false,
            parseFloat)),
        sortDirection: "descending",
      });
    }
    // The user wants to order the live list by amplitude descending
    else if (clickedColumn === "amplitude" && this.state.sortDirection === "descending") {
      this.setState({
        column: clickedColumn,
        devices: this.state.devices.sort(
          UtilsInstance.sortBy(
            "amplitude",
            true,
            parseFloat)),
        sortDirection: "ascending",
      });
    }
    // The user wants to order the live list by min amplitude ascending
    else if (clickedColumn === "minAmplitude" && this.state.sortDirection === "ascending") {
      this.setState({
        column: clickedColumn,
        devices: this.state.devices.sort(
          UtilsInstance.sortBy(
            "amplitudeMin",
            false,
            parseFloat)),
        sortDirection: "descending",
      });
    }
    // The user wants to order the live list by min amplitude descending
    else if (clickedColumn === "minAmplitude" && this.state.sortDirection === "descending") {
      this.setState({
        column: clickedColumn,
        devices: this.state.devices.sort(
          UtilsInstance.sortBy(
            "amplitudeMin",
            true,
            parseFloat)),
        sortDirection: "ascending",
      });
    }
    // The user wants to order the live list by jitter ascending
    else if (clickedColumn === "jitter" && this.state.sortDirection === "ascending") {
      this.setState({
        column: clickedColumn,
        devices: this.state.devices.sort(
          UtilsInstance.sortBy(
            "jitter",
            false,
            parseFloat)),
        sortDirection: "descending",
      });
    }
    // The user wants to order the live list by jitter descending
    else if (clickedColumn === "jitter" && this.state.sortDirection === "descending") {
      this.setState({
        column: clickedColumn,
        devices: this.state.devices.sort(
          UtilsInstance.sortBy(
            "jitter",
            true,
            parseFloat)),
        sortDirection: "ascending",
      });
    }
    // The user wants to order the live list by noise ascending
    else if (clickedColumn === "noise" && this.state.sortDirection === "ascending") {
      this.setState({
        column: clickedColumn,
        devices: this.state.devices.sort(
          UtilsInstance.sortBy(
            "noise",
            false,
            parseFloat)),
        sortDirection: "descending",
      });
    }
    // The user wants to order the live list by noise descending
    else if (clickedColumn === "noise" && this.state.sortDirection === "descending") {
      this.setState({
        column: clickedColumn,
        devices: this.state.devices.sort(
          UtilsInstance.sortBy(
            "noise",
            true,
            parseFloat)),
        sortDirection: "ascending",
      });
    }
    // The user wants to order the live list by min amplitude ascending
    else if (clickedColumn === "unbalance" && this.state.sortDirection === "ascending") {
      this.setState({
        column: clickedColumn,
        devices: this.state.devices.sort(
          UtilsInstance.sortBy(
            "unbalance",
            false,
            parseFloat)),
        sortDirection: "descending",
      });
    }
    // The user wants to order the live list by min amplitude descending
    else if (clickedColumn === "unbalance" && this.state.sortDirection === "descending") {
      this.setState({
        column: clickedColumn,
        devices: this.state.devices.sort(
          UtilsInstance.sortBy(
            "unbalance",
            true,
            parseFloat)),
        sortDirection: "ascending",
      });
    }
    // The user wants to order the live list by signal ascending
    else if (clickedColumn === "signal" && this.state.sortDirection === "ascending") {
      this.setState({
        column: clickedColumn,
        devices: this.state.devices.sort(
          UtilsInstance.sortBy(
            "severity",
            false,
            parseInt)),
        sortDirection: "descending",
      });
    }
    // The user wants to order the live list by signal descending
    else if (clickedColumn === "signal" && this.state.sortDirection === "descending") {
      this.setState({
        column: clickedColumn,
        devices: this.state.devices.sort(
          UtilsInstance.sortBy(
            "severity",
            true,
            parseInt)),
        sortDirection: "ascending",
      });
    }
  }

  // Creates a list with entries that match the address passed on the form
  handleAddressSearch = () => {
    const searchedDevices = [];

    for (let i = 0; i < this.state.originalDevices.length; i++) {
      if (this.state.originalDevices[i].address === parseInt(this.state.formInput)) {
        searchedDevices.push(this.state.originalDevices[i]);
      }
    }

    if (searchedDevices.length > 0) {
      this.setState({ devices: searchedDevices });
    } else {
      this.setState({ devices: [] });
    }
  }
  // Creates a list with entries that match the status passed on the form
  handleSignalSearch = (statusArray) => {
    const searchedDevices = [];

    for (let i = 0; i < statusArray.length; i++) {
      for (let j = 0; j < this.state.originalDevices.length; j++) {
        if (this.state.originalDevices[j].status === statusArray[i]) {
          searchedDevices.push(this.state.originalDevices[j]);
        }
      }
    }

    if (searchedDevices.length > 0) {
      this.setState({ devices: searchedDevices });
    } else {
      this.setState({ devices: [] });
    }
  }

  /*
    If the user typed a substring of one of the possible status: (In uppercase, lowercase or a mix of them)
    it returns and array containing the indexes to match against the json received from the server
  */
  matchFormInputStatus = () => {
    let matchedArray = [-1];
    let matchedIndex = 0;

    for (let i = 0; i < statusKeyArray.length; i++) {
      // Uppercases the user input before comparison to allow for a more flexible search
      // It doesn't matter if the user typed in uppercase, lowercase or any combination of them
      const status = statusKeyArray[i].toUpperCase();
      const upperCaseUserInput = this.state.formInput.toUpperCase();
      if (status.indexOf(upperCaseUserInput) !== -1) {
        matchedArray[matchedIndex] = i;
        matchedIndex++;
      }
    }

    return matchedArray;
  }

  /*
    Filters the page list showing only the devices that match the address or status typed in the form
  */
  handleSubmit = () => {
    const matchValueArray = this.matchFormInputStatus();
    let auxArray = [];

    for (let i = 0; i < matchValueArray.length; i++) {
      auxArray.push(statusValueArray[matchValueArray[i]]);
    }

    if (this.state.formInput !== "" && matchValueArray[0] !== -1) {
      this.handleSignalSearch(auxArray);
    }
    else if (this.state.formInput === "") {
      this.setState({ devices: this.state.originalDevices });
    }
    // If what the user typed is not a status and the form is not blank, try to see if he typed a number
    else {
      this.handleAddressSearch();
    }
  }

  retrieveData = async () => {
    // Retrieve devices list only if the input form is empty and the user didn't 
    // sort the table by clicking a column header
    if (this.state.formInput === "" && !this.state.isColumnClicked) {
      let promissesArray = [];

      promissesArray.push(
        fetch(Constants.REQUEST_IP_ADDRESS + "liveList/" + parseInt(localStorage.getItem(Constants.ACTIVE_CHANNEL)), { mode: "cors" })
          .then(res => res.json())
          .then(data => data)
          .catch((error) => {
            console.log(error);
          })
      );

      promissesArray.push(
        fetch(Constants.REQUEST_IP_ADDRESS + "networkData/" + parseInt(localStorage.getItem(Constants.ACTIVE_CHANNEL)), { mode: "cors" })
          .then(res => res.json())
          .then(data => data)
          .catch((error) => {
            console.log(error);
          })
      );

      promissesArray.push(
        fetch(Constants.REQUEST_IP_ADDRESS + "warnings/" + parseInt(localStorage.getItem(Constants.ACTIVE_CHANNEL)), { mode: "cors" })
          .then(res => res.json())
          .then(data => data)
      );

      promissesArray.push(
        fetch(Constants.REQUEST_IP_ADDRESS + "homePage", { mode: "cors" })
          .then(res => res.json())
          .then(data => data)
      );

      promissesArray.push(
        fetch(Constants.REQUEST_IP_ADDRESS + "getChannelTagsAndNotes/" + parseInt(localStorage.getItem(Constants.ACTIVE_CHANNEL)), {
          mode: "cors",
        })
          .then(res => res.json())
          .then(data => data)
      );

      let resolvedPromisses = await Promise.all(promissesArray);

      let liveList = resolvedPromisses[0];
      let networkData = resolvedPromisses[1];
      let warnings = resolvedPromisses[2];
      let homePage = resolvedPromisses[3];
      let channelTag = resolvedPromisses[4].tag;
      this.addOrderAndSeverityToDevices(liveList);

      this.setState({
        devices: liveList,
        originalDevices: liveList,
        // Network Data
        baudrate: networkData.baudrate,
        nMasters: networkData.nMasters,
        nSlaves: networkData.nSlaves,
        // Warnings
        InitPicoNotFound: warnings.InitPicoNotFound,
        firstScanFail: warnings.firstScanFail,
        // Uptime e tag
        uptime: this.formatToRelativeTime(homePage.uptime),
        channelTag: channelTag
      });

    }
  }

  handleLineClick = (address, hasWaveProblem) => () => {
    if (hasWaveProblem) {
      this.setState({ clickedDevice: address}, () => {
        this.setState({ showModal: true });
      });
    }
  }

  /* 
    Create Status Cell
    parameters: 
    - device: JSON information of the device being added to the table
    - return: A new table cell stylized according to the current device status
  */
  createStatusCell = (device) => {
    if (device.status === Constants.GOOD) {
      if (device.hasWaveProblem) {
        return (
          <Table.Cell
            selectable
            width={2}
            style={okFadedCellStyle}
            onClick={this.handleLineClick(device.address, device.hasWaveProblem)}>
            {Strings.GOOD_STRING}
          </Table.Cell>
        );
      }
      else {
        return (
          <Table.Cell
            selectable
            width={2}
            style={okCellStyle}>
            {Strings.GOOD_STRING}
          </Table.Cell>
        );
      }
    }
    else if (device.status === Constants.ATTENTION) {
      if (device.hasWaveProblem) {
        return (
          <Table.Cell
            selectable
            width={2}
            style={attentionFadedCellStyle}
            onClick={this.handleLineClick(device.address, device.status)}>
            {Strings.ATTENTION_STRING}
          </Table.Cell>
        );
      }
      else {
        return (
          <Table.Cell
            selectable
            width={2}
            style={attentionCellStyle}>
            {Strings.ATTENTION_STRING}
          </Table.Cell>
        );
      }
    }
    else if (device.status === Constants.BAD) {
      if (device.hasWaveProblem) {
        return (
          <Table.Cell
            selectable
            width={2}
            style={badFadedCellStyle}
            onClick={this.handleLineClick(device.address, device.status)}>
            {Strings.BAD_STRING}
          </Table.Cell>
        );
      }
      else {
        return (
          <Table.Cell
            selectable
            width={2}
            style={badCellStyle}>
            {Strings.BAD_STRING}
          </Table.Cell>
        );
      }
    }
    else if (device.status === Constants.FAULT) {
      return (
        <Table.Cell
          selectable
          width={2}
          style={faultCellStyle}>
          {Strings.FAULT_STRING}
        </Table.Cell>
      );
    }
    else {
      return (
        <Table.Cell
          selectable
          width={2}
          style={unknownCellStyle}>
          {Strings.UNKNOWN_STRING}
        </Table.Cell>
      );
    }
  }

  /*
    Adjusts the size of the table so that it does not exceed the
    browser window height limit
  */
  adjustTableMaxHeight = () => {
    const browserHeight = UtilsInstance.getBrowserWindowHeight();
    let newTableMaxHeight = browserHeight * Constants.SCALING_FACTOR_LIVE_TOPOLOGY;
    newTableMaxHeight = newTableMaxHeight.toString();
    newTableMaxHeight = newTableMaxHeight.concat("px");
    document.getElementById("main-table-container").style["maxHeight"] = newTableMaxHeight;
  }

  /*
    Saves the form input to the component state everytime the user
    types something in the form
  */
  handleChange = (e, { name, value }) => this.setState({ [name]: value })

  retrieveWarnings = () => {
    fetch(Constants.REQUEST_IP_ADDRESS + "warnings/" + parseInt(localStorage.getItem(Constants.ACTIVE_CHANNEL)), { mode: "cors" })
      .then(res => res.json())
      .then(data => { this.handleWarningMessages(data); });
  }

  handleWarningMessages = (errors) => {
    let errorMessages = [];

    if (errors.invertedPolarity || errors.mongoOFF || errors.picoNotFound || errors.scanFail) {
      // If at least one of the errors above ocurred, unhide the error message's container
      if (document.getElementById("message-list") !== undefined
        && document.getElementById("message-list") !== null) {
        document.getElementById("message-list").style.display = "block";
      }

      if (errors.invertedPolarity) {
        errorMessages.push(Strings.INVERTED_POLARITY);
      }

      if (errors.InitPicoNotFound) {
        errorMessages.push(Strings.INIT_PICO_NOT_FOUND);
      }

      if (errors.firstScanFail) {
        errorMessages.push(Strings.NO_ACTIVE_NETWORK);
      }

      if (errors.mongoOFF) {
        errorMessages.push(Strings.MONGO_OFF);
      }

      if (errors.picoNotFound) {
        errorMessages.push(Strings.PICO_NOT_FOUND);
      }

      if (errors.scanFail) {
        errorMessages.push(Strings.SCAN_FAIL_FOUND);
      }

      this.setState({ errorMessages: errorMessages });
    }
    else {

      if (document.getElementById("message-list") !== undefined
        && document.getElementById("message-list") !== null) {
        document.getElementById("message-list").style.display = "none";

      }

      this.setState({ errorMessages: [] });
    }
  }

  createDeviationCell = (device) => {
    if (device.nonStandardDeviation) {
      return (
        <Table.Cell
          style={nonStdDeviationCellStyle}
          width={2}
          verticalAlign="middle">
          {device.deviation.toFixed(2).replace(".", ",") + Strings.MICROSSECOND}
        </Table.Cell>
      );
    }
    else {
      return (
        <Table.Cell
          width={2}
          verticalAlign="middle">
          {device.deviation.toFixed(2).replace(".", ",") + Strings.MICROSSECOND}
        </Table.Cell>
      );
    }
  }

  getAmplitudeText = (amplitude) => {
    return amplitude.toFixed(2).replace(".", ",") + Strings.VOLTAGE_PEAK_TO_PEAK;
  }

  getNoiseText = (noise) => {
    if (noise === null) {
      return "0 " + Strings.MILLIVOLT;
    }
    else {
      return (noise * 1000).toFixed(2) + " " + Strings.MILLIVOLT;
    }
  }

  /// ---------------- Errors Accordion -----------------------------
  handleAccordionClick = (e, titleProps) => {
    const { index } = titleProps;
    const { accordionIndex } = this.state;
    const newIndex = accordionIndex === index ? -1 : index;

    this.setState({ accordionIndex: newIndex });
  };

  // ----------------- Lifecycle Methods ----------------
  componentDidMount() {
    //console.log("Live List / channel: ", parseInt(localStorage.getItem(Constants.ACTIVE_CHANNEL)));
    this.retrieveData();
    this.retrieveWarnings();
    // store intervalId in the state so it can be accessed later
    this.setState({
      intervalID: setInterval(this.retrieveData, 1000),
      warningsIntervalID: setInterval(this.retrieveWarnings, 5000),
    });
    this.adjustTableMaxHeight();
  }

  componentWillUnmount() {
    clearInterval(this.state.intervalID);
    clearInterval(this.state.warningsIntervalID);
  }

  componentDidUpdate() {
    this.adjustTableMaxHeight();
  }

  // Render the table containing all network devices
  render() {
    const column = this.state.column;
    const direction = this.state.sortDirection;
    const filter = this.state.formInput;

    const devices = this.state.devices.map(device => (
      <Table.Row key={device.address}>
        <Table.Cell width={2} verticalAlign="middle">{device.address}{UtilsInstance.getMasterSuffix(device.isMaster)}</Table.Cell>
        <Table.Cell width={3} verticalAlign="middle">{device.tag}</Table.Cell>
        <Table.Cell width={2} verticalAlign="middle">{(device.amplitude * 1000).toFixed(2)} {Strings.MILLIVOLT}</Table.Cell>
        <Table.Cell width={2} verticalAlign="middle">{(device.amplitudeMin * 1000).toFixed(2)} {Strings.MILLIVOLT}</Table.Cell>
        <Table.Cell width={2} verticalAlign="middle">{this.getNoiseText(device.noise)}</Table.Cell>
        <Table.Cell width={2} verticalAlign="middle">{device.jitter.toFixed(2) + Strings.MICROSSECOND}</Table.Cell>
        <Table.Cell width={2} verticalAlign="middle">{device.unbalance.toFixed(2) + " %"}</Table.Cell>
        {this.createStatusCell(device)}
      </Table.Row>
    ));

    return (
      <div>
        <Grid style={gridStyle} columns={3} verticalAlign="middle" doubling>
          <Grid.Row>
            <Grid.Column>
            </Grid.Column>

            <Grid.Column>
              <Form onSubmit={this.handleSubmit} >
                <Form.Input
                  id="inputform"
                  placeholder={Strings.LIVE_LIST_INPUT_TEXT_PLACEHOLDER}
                  icon="search"
                  name="formInput"
                  value={filter}
                  onChange={this.handleChange} />
              </Form>
            </Grid.Column>

            <Grid.Column>
              <Segment style={{ float: "right", marginRight: "1vw" }} compact textAlign="center">
                <Icon color="green" name="arrow alternate circle up" />
                Tempo ligado: {this.state.uptime}
              </Segment>
            </Grid.Column>
          </Grid.Row>
        </Grid>

        <Grid style={gridStyle} columns={2} doubling>
          <Grid.Row>

            <Grid.Column width={3}>
              <Segment>
                <Divider horizontal style={dividerStyle}>{Strings.NETWORK_DATA}</Divider>
                <Statistic.Group widths={1} size="mini">
                  <Statistic>
                    <Statistic.Value>{Constants.H1_BAUD_RATE}</Statistic.Value>
                    <Statistic.Label>{Strings.BAUD_RATE_KBPS}</Statistic.Label>
                  </Statistic>
                  <Statistic>
                    <Statistic.Value>{this.state.nMasters}</Statistic.Value>
                    <Statistic.Label>{Strings.MASTERS}</Statistic.Label>
                  </Statistic>
                  <Statistic>
                    <Statistic.Value>{this.state.nSlaves}</Statistic.Value>
                    <Statistic.Label>{Strings.SLAVES}</Statistic.Label>
                  </Statistic>
                  <Statistic>
                    <Statistic.Value>{parseInt(localStorage.getItem(Constants.ACTIVE_CHANNEL))}</Statistic.Value>
                    <Statistic.Label>{Strings.CURRENT_CHANNEL}</Statistic.Label>
                  </Statistic>
                  <Statistic>
                    <Statistic.Value>{this.state.channelTag}</Statistic.Value>
                    <Statistic.Label>{Strings.CHANNEL_TAG_STR}</Statistic.Label>
                  </Statistic>
                </Statistic.Group>
              </Segment>

              <Accordion id="message-list" styled style={accordionStyle}>
                <Accordion.Title
                  style={accordionTitleStyle}
                  active={this.state.accordionIndex === 1}
                  index={1}
                  onClick={this.handleAccordionClick}
                >
                  <Icon name="exclamation triangle" />
                  {Strings.DETECTED_PROBLEMS}
                  <Icon name="dropdown" />
                </Accordion.Title>
                <Accordion.Content active={this.state.accordionIndex === 1}>
                  <div style={accordionListItemsStyle}>
                    <ul style={{ paddingLeft: 0 }}>
                      {this.state.errorMessages.map((message) => (
                        <li key={message}>{message}</li>
                      ))}
                    </ul>
                  </div>
                </Accordion.Content>
              </Accordion>

            </Grid.Column>

            <Grid.Column width={13}>
              <Table id="table-header" style={headerMarginStyle} sortable striped celled fixed singleLine selectable textAlign="center">
                <Table.Header>
                  <Table.Row>
                    <Table.HeaderCell
                      width={2}
                      sorted={column === "address" ? direction : null}
                      onClick={this.handleSort("address")}>
                      {Strings.ADDRESS}
                    </Table.HeaderCell>

                    <Table.HeaderCell
                      width={3}
                      sorted={column === "tag" ? direction : null}
                      onClick={this.handleSort("tag")}>
                      {Strings.TAG}
                    </Table.HeaderCell>

                    <Table.HeaderCell
                      width={2}
                      sorted={column === "amplitude" ? direction : null}
                      onClick={this.handleSort("amplitude")}>
                      {Strings.AMPLITUDE}
                    </Table.HeaderCell>

                    <Table.HeaderCell
                      width={2}
                      sorted={column === "minAmplitude" ? direction : null}
                      onClick={this.handleSort("minAmplitude")}>
                      {Strings.AMPLITUDE}<br/>
                      {Strings.MINIMUM_FEM}
                    </Table.HeaderCell>

                    <Popup position='bottom center' hoverable pinned
                      trigger={
                        <Table.HeaderCell
                          width={2}
                          sorted={column === "noise" ? direction : null}
                          onClick={this.handleSort("noise")}>
                          {Strings.NOISE}
                          <span style={spanStyle}>
                            <Icon name="info circle" color="teal" />
                          </span>
                        </Table.HeaderCell>
                      }>
                      <Popup.Content>
                        O <b>Ruído</b> é calculado durante o tempo de <b><i>idle</i></b> de cada um dos Devices na rede e não deve exceder <b>100 mV</b>.<br />
                        Estes valores são de ordem prática.
                      </Popup.Content>
                    </Popup >

                    <Popup position='bottom center' hoverable pinned
                      trigger={
                        <Table.HeaderCell
                          width={2}
                          sorted={column === "jitter" ? direction : null}
                          onClick={this.handleSort("jitter")}>
                          {Strings.JITTER}
                          <span style={spanStyle}>
                            <Icon name="info circle" color="teal" />
                          </span>
                        </Table.HeaderCell>
                      }>
                      <Popup.Content style={popupContentStyle}>
                        O <b>Jitter</b> é o deslocamento do sinal no tempo em relação ao zero ideal.<br />
                        Caso ocorra, pode fazer com que a eletrônica do device não consiga ler a mensagem.<br />
                        Seu valor definido por norma deve ser menor que <b>± 0,1 T<sub>bit</sub></b>, que equivale a <b>3,2 &#181;s</b>.
                      </Popup.Content>
                    </Popup >

                    <Popup position='bottom center' hoverable pinned
                      trigger={
                        <Table.HeaderCell
                          width={2}
                          sorted={column === "unbalance" ? direction : null}
                          onClick={this.handleSort("unbalance")}>
                          {Strings.UNBALANCE}
                          <span style={spanStyle}>
                            <Icon name="info circle" color="teal" />
                          </span>
                        </Table.HeaderCell>
                      }>
                      <Popup.Content style={popupContentStyle}>
                        O <b>desbalanceamento</b> é a medida do deslocamento do sinal com relação ao zero AC, ou seja, se o sinal está deslocado para cima ou para baixo. <br />
                        Faz-se esta medida pela diferença da média da parte negativa e positiva do sinal. <br />
                        Indica, geralmente problema na eletrônica dos equipamentos, sendo a principal delas uma possível falha no isolamento da alimentação/sinal.
                        {this.getUnbalanceImage()}
                      </Popup.Content>
                    </Popup >

                    <Popup wide position='bottom center' hoverable pinned
                      trigger={
                        <Table.HeaderCell
                          width={2}
                          sorted={column === "signal" ? direction : null}
                          onClick={this.handleSort("signal")}>
                          {Strings.SIGNAL}
                          <span style={spanStyle}>
                            <Icon name="info circle" color="teal" />
                          </span>
                        </Table.HeaderCell>
                      }>
                      <Popup.Content>
                        <div>
                          <p style={popupTitleStyle}>Qualidade do sinal</p>
                          <div style={popupTitleStyle}>Bom</div>
                          • Amplitude entre 750 e 1000 mV<sub>pp</sub>. Sinal dentro da norma!
                          <div style={popupTitleStyle}>Atenção</div>
                          • Amplitude entre 500 e 750 mV<sub>pp</sub><br />
                          • Amplitude entre 1000 e 1250 mV<sub>pp</sub>
                          <div style={popupTitleStyle}>Ruim</div>
                          • Amplitude menor que 500 mV<sub>pp</sub>. Pode ser causada por excesso de terminadores, barramento muito longo, umidade, etc.<br />
                          • Amplitude maior que 1250 mV<sub>pp</sub>. Pode ser causada pela falta de terminadores, problemas em equipamentos, etc.
                          <div style={popupTitleStyle}>Sem sinal</div>
                          • O TS Scope H1 não está encontrando resposta do devices.
                        </div>
                      </Popup.Content>
                    </Popup >

                  </Table.Row>
                </Table.Header>
              </Table>

              <div id="main-table-container" style={tableStyle}>
                <Table id="main-table" sortable striped celled fixed selectable textAlign="center" columns={7}>
                  <Table.Body>{devices}</Table.Body>
                </Table>

                <Modal centered open={this.state.showModal} onClose={this.closeModal} basic size='small'>
                  <Header icon='trash' content={Strings.REMOVE_POSITIONING} />
                  <Modal.Content>
                    <p>{Strings.REMOVE_DEVICE_MODAL_CONTENT_1}</p>
                    {/* <p><b>{Strings.PS}</b> {Strings.REMOVE_LOST_IP_MODAL_CONTENT_2}</p> */}
                  </Modal.Content>
                  <Modal.Actions>
                    <Button color='red' inverted onClick={this.closeModal}><Icon name='remove' />{Strings.NO}</Button>
                    <Button color='green' inverted onClick={this.handleModalDeleteClick}><Icon name='checkmark' />{Strings.YES}</Button>
                  </Modal.Actions>
                </Modal>
              </div>

            </Grid.Column>

          </Grid.Row>
        </Grid>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  channel: state.activeMenuItem.channel
});

// CSS custom table stylization
const gridStyle = {
  marginLeft: "2vw",
  marginRight: "2vw"
};

const tableStyle = {
  overflowY: "scroll"
};

const headerMarginStyle = {
  marginBottom: "1vh",
  width: "99.4%"
};

const okCellStyle = {
  color: "black",
  backgroundColor: "lime",
  verticalAlign: "middle"
};

const okFadedCellStyle = {
  color: "black",
  backgroundColor: "rgba(0, 255, 0, 0.3)",
  verticalAlign: "middle"
};

const attentionCellStyle = {
  color: "black",
  backgroundColor: "yellow",
  verticalAlign: "middle"
};

const attentionFadedCellStyle = {
  color: "black",
  backgroundColor: "rgba(255, 255, 0, 0.3)",
  verticalAlign: "middle"
};

const badCellStyle = {
  color: "black",
  backgroundColor: "#FF5722",
  verticalAlign: "middle"
};

const badFadedCellStyle = {
  color: "black",
  backgroundColor: "rgba(255, 87, 34, 0.3)",
  verticalAlign: "middle"
};

const faultCellStyle = {
  color: "black",
  backgroundColor: "darkgrey",
  verticalAlign: "middle"
};

const unknownCellStyle = {
  color: "black",
  backgroundColor: "lightgrey",
  verticalAlign: "middle"
};

const nonStdDeviationCellStyle = {
  backgroundColor: "#ff6600"
};

const dividerStyle = {
  marginTop: "-0.2vh"
};

const spanStyle = {
  float: "right"
};

const accordionStyle = {
  color: "#9F3A38",
  backgroundColor: "#FFF6F6",
  display: "none",
  marginBottom: "2vh",
};

const accordionTitleStyle = {
  color: "#9F3A38",
  textAlign: "center"
};

const accordionListItemsStyle = {
  textAlign: "left",
  listStylePosition: "inside",
};

const popupTitleStyle = {
  fontWeight: "bold",
  textAlign: "center"
};

const popupContentStyle = {
  textAlign: "center"
};

export default connect(mapStateToProps)(withRouter(LiveList));
